import { useAuthMe, useExitImpersonation } from '../api/queries';

/**
 * Persistent landmark banner shown whenever the current session carries an `act` claim.
 *
 * Uses role="region" + aria-label (NOT aria-live / role=status) — this is a persistent
 * indicator, not a transient announcement. Banner text is derived from the top-level
 * AuthMeResponse identity (the target organiser the operator is acting as), NOT from
 * the actingAs block, which by design contains no organiser- or admin-identifying fields.
 *
 * Renders nothing — including no DOM — until useAuthMe resolves so we don't display a
 * banner-then-not-banner flash for normal organiser sessions.
 */
export function ImpersonationBanner() {
  const me = useAuthMe();
  const exit = useExitImpersonation();

  // Don't render until first resolution.
  if (me.isLoading && !me.data) {
    return null;
  }
  if (!me.data?.actingAs) {
    return null;
  }

  const target = me.data.displayName ?? me.data.email;
  return (
    <div
      role="region"
      aria-label="Impersonation banner"
      style={{
        background: '#FFD400',
        color: '#1a1a1a',
        padding: '8px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontWeight: 600,
        borderBottom: '1px solid #c79f00',
      }}
    >
      <span>Acting as {target} — exit impersonation</span>
      <button
        type="button"
        onClick={() => exit.mutate()}
        disabled={exit.isPending}
        style={{
          background: '#1a1a1a',
          color: '#fff',
          border: 0,
          padding: '6px 12px',
          borderRadius: 4,
          cursor: 'pointer',
          fontWeight: 600,
        }}
      >
        {exit.isPending ? 'Exiting…' : 'Exit impersonation'}
      </button>
    </div>
  );
}
